


















import Vue from 'vue';
import CarSelector from '@/components/CarSelector.vue';
import Helpers from '../mixins/helpers';
import Analytics from '../mixins/analytics';
import { mapState } from 'vuex';

export default Vue.extend({
    name: 'HomePage',
    components: {
		CarSelector
	}, 
	computed: {
		...mapState({
			showSpecialOffer(): boolean {
				return this.$store.state.app.showSpecialOffer;
			},
			customer(): object {
				return this.$store.state.customer;
			},
			session(): string {
				return this.$store.state.app.session;
			},
			vehicle(): any {
				return this.$store.state.vehicle;
			},
			dealer(): any {
				return this.$store.state.dealer;
			}, 
			lightTheme(): boolean {
				return this.$store.state.app.theme == 'light';
			}
		}), 
		vehiclePrice(): string {
			return this.vehicle.DriveawayPrice ? Helpers.getFormattedPrice(this.vehicle.DriveawayPrice) : '';
		}
	}, 
	methods: {
		handleRegisterNowClick(): void {
			Analytics.sendRegisterNow();
		},
		handleLoginUpdate(): void {
			setTimeout(() => {
				this.$vuetify.goTo((this.$refs.reserveForm as any), {duration: 500, offset: 12})
				this.setFirstFocus();
			}, 500);
		},
		handlePrivacyPolicyClick(): void {
			Analytics.sendButtonClick('privacy Policy');
			this.$store.commit('setOpenModal', {
				id: 'PrivacyModal'
			});
		},
		setFirstFocus(): void {
			setTimeout(() => {
				(this.$refs.ppButton as any).focus();
			}, 600); 
		}
	}
})
